import { getUserCookie } from "../../../utils/cookiesUtils";
import "../../../styles/org-buttons.css";
import { buttonText } from "../../../utils/buttonText";

function MainPage(props) {
  const { setCurrentPage } = props;

  const userData = getUserCookie();
  const role = userData ? userData.role : null;

  let display = (
    <div className="acquisition-upload-page">
      <button
        type="button"
        className="org-btn org-btn-secondary"
        onClick={() => setCurrentPage("MntPage")}
      >
        {buttonText("From Dir")}
      </button>
      <button
        type="button"
        className="org-btn org-btn-secondary"
        onClick={() => setCurrentPage("datasetPage")}
      >
        {buttonText("Clone Dataset")}
      </button>
      <button
        type="button"
        className="org-btn org-btn-secondary"
        onClick={() => setCurrentPage("FiftyonePage")}
      >
        {buttonText("FiftyOne")}
      </button>
    </div>
  );
  if (role === "annotator") {
    display = (
      <div className="acquisition-upload-page">
        <button
          type="button"
          className="org-btn org-btn-secondary"
          onClick={() => setCurrentPage("datasetPage")}
        >
          {buttonText("Clone Dataset")}
        </button>
      </div>
    );
  }

  return display;
}

export default MainPage;
